import React from 'react';
import { useTranslation } from 'react-i18next';
import { useToggleSaveMyContent } from 'actions/content';
import Button from 'components/Button';
export default function SaveButton(_ref) {
  var playlist = _ref.playlist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isSaved = playlist.isSaved;
  var _useToggleSaveMyConte = useToggleSaveMyContent({
      id: playlist.id,
      isSaved: !isSaved,
      isAsset: false,
      isRecommended: playlist.recommended
    }),
    toggleSaveContent = _useToggleSaveMyConte.toggleSaveContent,
    isLoading = _useToggleSaveMyConte.isLoading;
  return /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "transparent",
    icon: "favourite",
    isDisabled: !playlist,
    isLoading: isLoading,
    onClick: function onClick() {
      return toggleSaveContent({
        id: playlist.id,
        isAsset: false
      });
    },
    isActive: isSaved
  }, t(isSaved ? 'actions_saved_for_later' : 'actions_save_for_later'));
}